// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip_wrapper__keKyw","layer":"Tooltip_layer__mOQ4U","story":"Tooltip_story__yTYi7"};